import { parsePointPerLineShapeCsvData, pointPerLineShapeDataToGeojson } from "../parsePointPerLineShapeCsv.js";

export async function csvToGeojsonConverter(file) {
  if (!file) return { geojson: null, errors: ["No file provided."] };

  const raw = await file.text();
  const withoutBom = raw.replace(/^\uFEFF/, "");
  const normalizedNewlines = withoutBom.replace(/\r\n/g, "\n");

  const parsed = parsePointPerLineShapeCsvData(normalizedNewlines);
  if (!parsed) {
    return {
      geojson: null,
      errors: [
        "Unsupported CSV format. Expected a point-per-line CSV with columns: id (or Matricule), geometry (PONCTUEL/LINEAIRE/SURFACIQUE), N° Point, X, Y.",
      ],
    };
  }

  const out = pointPerLineShapeDataToGeojson(parsed);
  if (out.errors?.length) return { geojson: null, errors: out.errors };
  return { geojson: out.geojson, errors: [] };
}

